/** Respects `scroll-padding-top` on `html` (sticky nav + safe area). */
export function scrollToSection(id, { behavior = 'smooth' } = {}) {
  if (typeof document === 'undefined' || !id) return false

  const el = document.getElementById(id)
  if (!el) return false

  const reducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches

  el.scrollIntoView({
    behavior: reducedMotion ? 'instant' : behavior,
    block: 'start',
    inline: 'nearest',
  })
  return true
}

export function scrollBehaviorForUser() {
  if (typeof window === 'undefined') return 'smooth'
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
}
